export default "__VITE_ASSET__B2DaJX3Z__"